import { TypographyProps } from '@mui/material';

export const ellipsisText = (nowrap = true): TypographyProps => ({
  overflow: 'hidden',
  whiteSpace: nowrap ? 'nowrap' : 'normal',
  textOverflow: 'ellipsis',
});
